<lib-dialog
  [title]="'staff-selection-dialog.text.title' | translate"
  (closeButtonClick)="closeDialog()"
>
  <div body style="width: 99%">
    <div
      class="flex-row-space-between"
      [class.highlight-text]="isStaffSelected(FIRST_AVAILABLE_STAFF_ID)"
    >
      <div>{{ 'staff-selection-dialog.text.first-available' | translate }}</div>

      <ng-container
        [ngTemplateOutlet]="selectButtonTemplate"
        [ngTemplateOutletContext]="{ staffId: FIRST_AVAILABLE_STAFF_ID }"
      ></ng-container>
    </div>

    <ng-container *ngFor="let staff of staffs">
      <lib-spacer [height]="10"></lib-spacer>
      <lib-divider></lib-divider>
      <lib-spacer [height]="10"></lib-spacer>

      <div
        class="flex-row-space-between"
        [class.highlight-text]="isStaffSelected(staff.id)"
      >
        <div>
          {{ staff | staffNameFormatter : staff.id }}
        </div>

        <ng-container
          [ngTemplateOutlet]="selectButtonTemplate"
          [ngTemplateOutletContext]="{ staffId: staff.id }"
        ></ng-container>
      </div>
    </ng-container>
  </div>

  <ng-container action>
    <lib-spacer></lib-spacer>
    <button mat-stroked-button color="primary" (click)="closeDialog()">
      {{ 'staff-selection-dialog.buttons.close' | translate }}
    </button>
    <lib-spacer></lib-spacer>
  </ng-container>
</lib-dialog>

<ng-template #selectButtonTemplate let-staffId="staffId">
  <div class="select-button-container">
    <button *ngIf="isStaffSelected(staffId)" mat-flat-button color="primary">
      {{ 'staff-selection-dialog.buttons.selected' | translate }}
    </button>
    <button
      *ngIf="!isStaffSelected(staffId)"
      mat-stroked-button
      color="primary"
      (click)="selectStaff(staffId)"
    >
      {{ 'staff-selection-dialog.buttons.select' | translate }}
    </button>
  </div>
</ng-template>
